import { render, staticRenderFns } from "./ListDocuments.vue?vue&type=template&id=b8ba0e00&scoped=true&lang=pug&"
import script from "./ListDocuments.vue?vue&type=script&lang=js&"
export * from "./ListDocuments.vue?vue&type=script&lang=js&"
import style0 from "./ListDocuments.vue?vue&type=style&index=0&id=b8ba0e00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ba0e00",
  null
  
)

export default component.exports